/**
 * Classe que gerencia a exibição da
 * Created by adalto on 5/9/14.
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.MapLayerActions = Greenmile.Toolbar.MapLayerActions || {};

Greenmile.Toolbar.MapLayerActions.LayerActualRoute = (function () {

    function LayerActualRoute () {

        Greenmile.Toolbar.MapLayerActions.Base.apply(this, arguments);

        this.LAYER_NAME = 'actual_route';
        this.RESOURCE_LAYER = 'RouteDetail.ToolBar.Layers.ActualRoute';

        var instanceToDataClass = null;

        this.setInstanceToClassData = function (instance) {
            instanceToDataClass = instance;
        };

        this.afterClickOnCheckBox = function (context) {

            return function () {

                var status = false;
                var _element = this;

                if (_element.checked) {

                    status = true;

                    if (instanceToDataClass) {
                        instanceToDataClass.enableCanMakeCoordinates();
                        instanceToDataClass.getCoordinatesAndDrawOnMap();
                    }

                } else {

                    if (instanceToDataClass) {
                        instanceToDataClass.removeActualRoute();
                        instanceToDataClass.blockCanMakeCoordinates();
                    }

                }

                context.setLayerStatusOnLocalStorageByTagName(status);

            };

        }(this);
    }

    return LayerActualRoute;

})();